import produce from 'immer';

import {readQuerySafe, writeFragmentsToCache, writeQuery} from 'graphql-client/ApolloWrappers';
import {getFragmentWrapper} from 'graphql-client/declarative-translations/external/getFragmentWrapper';
import {AllProcessTaskSchemasForSchemaConfigQuery} from 'processes/modals/utils/__generated/AllProcessTaskSchemasForSchemaConfigQuery';
import {ProcessesAllSchemasQuery} from 'processes/modals/utils/__generated/ProcessesAllSchemasQuery';
import {
  ALL_PROCESS_TASK_SCHEMAS_FOR_SCHEMA_CONFIG_QUERY,
  PROCESSES_ALL_SCHEMAS_QUERY,
} from 'processes/modals/utils/ProcessesAllSchemasQueryUtils';

type ProcessTaskSchemaGQL = ProcessesAllSchemasQuery['processTaskSchemasSupportingPlatformFeature'][number];

export function isEmptyOrWhitespace(str: string): RegExpMatchArray | null {
  return str.match(/^\s*$/g);
}

export function insertOrReplaceTaskSchema(
  taskSchemas: Array<ProcessTaskSchemaGQL>,
  taskSchemaToInsert: ProcessTaskSchemaGQL
): Array<ProcessTaskSchemaGQL> {
  return produce(taskSchemas, (draftTaskSchemas) => {
    const schemaIdx = draftTaskSchemas.findIndex(({id}) => taskSchemaToInsert.id === id);
    if (schemaIdx < 0) {
      draftTaskSchemas.push(taskSchemaToInsert);
    } else {
      draftTaskSchemas[schemaIdx] = taskSchemaToInsert;
    }
  });
}

export function cacheUpdatedTaskSchema(updatedTaskSchema: ProcessTaskSchemaGQL): void {
  const allSchemasResult = readQuerySafe<ProcessesAllSchemasQuery>({
    query: PROCESSES_ALL_SCHEMAS_QUERY,
  });
  if (allSchemasResult != null) {
    const taskSchemasWithUpdate = insertOrReplaceTaskSchema(
      allSchemasResult.processTaskSchemasSupportingPlatformFeature,
      updatedTaskSchema
    );
    writeQuery(
      {query: PROCESSES_ALL_SCHEMAS_QUERY},
      {
        ...allSchemasResult,
        processTaskSchemas: taskSchemasWithUpdate,
        __typename: 'Query',
      }
    );
    writeFragmentsToCache(getFragmentWrapper('AllProcessTaskSchemasForSchemaConfig'), [
      {processTaskSchemasSupportingPlatformFeature: taskSchemasWithUpdate, __typename: 'Query'},
    ]);
  }

  const processTaskSchemaResult = readQuerySafe<AllProcessTaskSchemasForSchemaConfigQuery>({
    query: ALL_PROCESS_TASK_SCHEMAS_FOR_SCHEMA_CONFIG_QUERY,
  });
  if (processTaskSchemaResult != null) {
    const taskSchemasWithUpdate = insertOrReplaceTaskSchema(
      processTaskSchemaResult.processTaskSchemasSupportingPlatformFeature,
      updatedTaskSchema
    );
    writeQuery(
      {query: ALL_PROCESS_TASK_SCHEMAS_FOR_SCHEMA_CONFIG_QUERY},
      {
        ...processTaskSchemaResult,
        processTaskSchemasSupportingPlatformFeature: taskSchemasWithUpdate,
        __typename: 'Query',
      }
    );
    writeFragmentsToCache(getFragmentWrapper('AllProcessTaskSchemasForSchemaConfig'), [
      {processTaskSchemasSupportingPlatformFeature: taskSchemasWithUpdate, __typename: 'Query'},
    ]);
  }

  writeFragmentsToCache(getFragmentWrapper('ProcessTaskSchema'), [updatedTaskSchema]);
}
